export const DDI_LIST = [
  { code: '+55', flag: '🇧🇷', label: 'Brasil' },
  { code: '+1', flag: '🇺🇸', label: 'EUA' },
  { code: '+351', flag: '🇵🇹', label: 'Portugal' },
  { code: '+54', flag: '🇦🇷', label: 'Argentina' },
  { code: '+34', flag: '🇪🇸', label: 'Espanha' },
  { code: '+52', flag: '🇲🇽', label: 'México' },
  { code: '+57', flag: '🇨🇴', label: 'Colômbia' },
  { code: '+56', flag: '🇨🇱', label: 'Chile' },
  { code: '+598', flag: '🇺🇾', label: 'Uruguai' },
  { code: '+595', flag: '🇵🇾', label: 'Paraguai' },
  { code: '+51', flag: '🇵🇪', label: 'Peru' },
  { code: '+44', flag: '🇬🇧', label: 'Reino Unido' },
  { code: '+49', flag: '🇩🇪', label: 'Alemanha' },
  { code: '+33', flag: '🇫🇷', label: 'França' },
  { code: '+39', flag: '🇮🇹', label: 'Itália' },
];

export function extractPhoneDdiAndLocal(raw) {
  if (!raw) return { ddi: '+55', local: '' };
  const str = String(raw);
  const matchSpaced = DDI_LIST.find(d => str.startsWith(d.code + ' '));
  if (matchSpaced)
    return {
      ddi: matchSpaced.code,
      local: str.slice(matchSpaced.code.length + 1),
    };
  const matchGlued = DDI_LIST.find(d => str.startsWith(d.code));
  if (matchGlued)
    return { ddi: matchGlued.code, local: str.slice(matchGlued.code.length) };
  return { ddi: '+55', local: str };
}

export function formatPhoneLocal(val) {
  const digits = String(val).replace(/\D/g, '').slice(0, 11);
  if (!digits) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 9)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  if (digits.length === 10)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3, 7)}-${digits.slice(7)}`;
}

export function formatPhoneDisplay(raw) {
  if (!raw) return '';
  const { ddi, local } = extractPhoneDdiAndLocal(raw);
  const flag = DDI_LIST.find(d => d.code === ddi)?.flag ?? '🇧🇷';
  const formattedLocal = formatPhoneLocal(local);
  return formattedLocal ? `${flag} ${formattedLocal}` : raw;
}
